import Marquee from "react-fast-marquee";

const items = [
  "Trusted Maid Services",
  "We Care Like Family",
  "Verified & Background Checked",
  "Spotless Results",
  "On-Time Service",
  "Trained Professionals",
];

export default function BrandMarquee() {
  return (
    <div className="py-8 md:py-10 border-y border-slate-200 bg-[var(--paper-2)]" data-testid="marquee">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-3xl md:text-5xl text-[var(--navy)] px-8 tracking-tight">
              {t}
            </span>
            <span className="h-2.5 w-2.5 rounded-full bg-[var(--gold)]" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
